<template>
  <gj-modal
    size="1200_auto"
    :visible.sync="modalVisible"
    :confirm-loading="loading"
  >
    <template #header>{{ state === "add" ? "添加" : state === "edit" ? "编辑" : "查看" }}模板</template>
    <template #content>
      <el-form ref="form" :model="form" label-width="74px">
        <el-form-item
          prop="countryMarketValue"
          label="国家店铺"
          class="is-required">
          <gj-country-server-select
            v-model="form.countryMarketValue"
            :disabled="canNotEdit"
            :width="['540px', '540px']">
          </gj-country-server-select>
        </el-form-item>
        <el-form-item
          prop="type"
          label="模板类型"
          :rules="[
            { required: true, message: '请选择模板类型', trigger: 'change', },
          ]">
          <gj-select
            v-model="form.type"
            :options="templateTypeOptions"
            :disabled="canNotEdit"
            width="100%"
            placeholder="请选择模板类型">
          </gj-select>
        </el-form-item>
        <el-form-item
          prop="name"
          label="模板名称"
          :rules="[
            { required: true, message: '请输入模板名称', trigger: ['change', 'blur'], },
          ]"
        >
          <gj-input
            v-model="form.name"
            width="100%"
            :disabled="canNotEdit"
            placeholder="请输入模板名称"
          ></gj-input>
        </el-form-item>
        <el-row :gutter="10">
          <el-col :span="18">
            <el-form-item
              prop="theme"
              label="邮件主题"
              :rules="[
                { required: true, message: '请输入邮件主题', trigger: ['change', 'blur'], },
              ]"
            >
              <gj-input
                v-model="form.theme"
                width="100%"
                @blur="onThemeInsert"
                :disabled="canNotEdit"
                placeholder="请输入邮件主题"
              ></gj-input>
            </el-form-item>
            <el-form-item
              prop="content"
              label="邮件内容"
              style="margin-bottom: 0;"
              :rules="[
                { required: true, message: '请输入邮件内容', trigger: ['change', 'blur'] },
              ]"
            >
              <gj-wang-editor
                ref="gjWangEditor"
                v-model="form.content"
                :readOnly="canNotEdit"
                @blur="gjWangEditorInsert"
                @focus="gjWangEditorInsert"
                :maxLength="4000"
                height="367">
              </gj-wang-editor>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <div>
              <gj-area-title>插入变量</gj-area-title>
            </div>
            <gj-cascader-select
              height="454px"
              :readOnly="canNotEdit"
              :insertType="insertType"
              :options="variableOptions"
              @change="insertVariable">
            </gj-cascader-select>
          </el-col>
        </el-row>
        <el-form-item class="gj-mt5" style="margin-bottom: 0;line-height: 20px;">
          <span @click="clickGuider" class="colorBlue gj-pointer">亚马逊沟通指南</span>
          <span @click="clickAttention" class="colorBlue gj-pointer gj-ml20">模板使用注意事项</span>
        </el-form-item>
      </el-form>
    </template>
    <template #footer>
      <gj-button v-if="state === 'add' || state === 'edit'" @click="cancel">取消</gj-button>
      <gj-button v-if="state === 'view'" @click="cancel">关闭</gj-button>
      <gj-button v-if="state === 'add' || state === 'edit'" type="primary" @click="confirm">确认</gj-button>
    </template>
  </gj-modal>
</template>

<script>
import { formRuleMixin, modalMixIn, responseMixin } from "../../../../../minxins";
import { isMeaningful } from "@/utils/common";
import { addMailTemplate, updateMailTemplate, getTemplateType, getMailTemplateVariable} from "../../../../../api/crm";
import GjWangEditor from '@/components/wang-editor/gj-wang-editor'
import GjCascaderSelect from '../components/cascader-select'
// import { variableOptions } from '@/utils/options'

export default {
  name: "mail-template-edit",
  components: { GjWangEditor, GjCascaderSelect },
  mixins: [modalMixIn, formRuleMixin, responseMixin],
  props: {
    item: null,
    state: {
      type: String,
      default: "add",
    },
  },
  created() {
    if (isMeaningful(this.item)) {

      this.form.id = this.item.id;
      // this.form.marketIds = (this.item.marketIds || []).map((v) => v + "");
      this.form.countryMarketValue = {
        countryIds: this.item.countryCodes,
        marketIds: this.item.marketIds
      }
      this.form.type = this.item.templateType;
      this.form.name = this.item.name;
      this.form.theme = this.item.emailSubject;
      let index = this.item.content.indexOf("<p>")
      if(index > -1) {
        this.form.content = this.item.content
      } else {
        this.form.content = this.item.content.split(/\n/).map(line => `<p>${line}</p>`).join('\n')
      }
    }
    this.canNotEdit = this.state === 'view' ? true : false
    this.requestTemplateType()
    this.requestMailTemplateVariable()
  },
  data() {
    return {
      loading: false,
      form: {
        id: null,
        countryMarketValue: null,
        type: null,
        name: null,
        theme: '',
        content: null
      },
      templateTypeOptions: [],
      activeName: null,
      variableOptions: [],
      canEdit:false,
      insertType: 'content', // theme/content ,区分插入类型 主题或者内容
      insertIndex: -1 // 变量插入主题位置
    };
  },
  methods: {
    clickGuider(){
      window.open("https://sellercentral.amazon.com/gp/help/external/G1701?language=zh_CN&ref=efph_G1701_cont_521")
    },
    clickAttention(){
      window.open("https://sellercentral.amazon.com/gp/help/external/200415980?language=zh_CN")
    },
    // 邮件主题input失焦
    onThemeInsert(ev) {
      this.insertType = 'theme'
      this.insertIndex = ev.srcElement.selectionStart
    },
    // 邮件内容富文本失焦
    gjWangEditorInsert() {
      this.insertType = 'content'
      this.insertIndex = this.form.theme.length
    },
    insertVariable(item) {
      if(this.insertType === 'theme') {
        if(item.type === 'Text'){
          this.form.theme = this.form.theme.substring(0, this.insertIndex) + item.preview + this.form.theme.substring(this.insertIndex)
          this.insertIndex += item.preview.length
        } else {
          this.$gjMessage.warning("邮件主题只能插入文本类变量！");
        }
      }else if(this.insertType === 'content') {
        this.$refs.gjWangEditor.insertVariable(item.preview)
      }
    },
    requestTemplateType() {
      getTemplateType()
        .then((res) => {
          this.$gjResponseHandle(res, () => {
            this.templateTypeOptions = res.data
          });
        })
        .complete(() => (this.loading = false));
    },
    requestMailTemplateVariable() {
      getMailTemplateVariable()
        .then((res) => {
          var array = []
          for (let i = 0; i < res.data.length; i++) {
            const dict = res.data[i];
            var tempDictChild = []
            dict.mailTemplateVariableList.map((item) => {
              let tempArrayDict = {
                id: item.variableValue,
                text: item.variableText,
                type: item.labelType, // Text，标签；Link，链接标签；Image，图片标签
                preview:item.variableValue
              }
              tempDictChild.push(tempArrayDict)
            })
            let tempDict = {
              id: dict.variableValue,
              text: dict.variableText,
              children: tempDictChild
            }
            array.push(tempDict)
            this.variableOptions = array
          }
        })
        .complete(() => (this.loading = false));
    },
    confirm() {
      if (this.$gjFormValidate()) {
          var paramsDict = {
            'content':this.form.content,//邮件内容
            'countryCodes':(this.form.countryMarketValue && this.form.countryMarketValue.countryIds) ? this.form.countryMarketValue.countryIds : [],//适用国家
            'emailSubject':this.form.theme,//邮件主题
            'marketIds':(this.form.countryMarketValue && this.form.countryMarketValue.marketIds) ? this.form.countryMarketValue.marketIds :[],//适用店铺
            'name':this.form.name,//模板名称
            'templateType':this.form.type,//模板类型
            'id':this.form.id ? this.form.id : ''
          }

        this.loading = true;
        if (this.state === "edit") {
          updateMailTemplate(paramsDict)
            .then((res) => {
              this.$gjResponseHandle(res, () => {
                this.$gjMessage.success("操作成功");
                this.$emit("after");
              });
            })
            .complete(() => (this.loading = false));
        } else {

          addMailTemplate(paramsDict)
            .then((res) => {
              this.$gjResponseHandle(res, () => {
                this.$gjMessage.success("操作成功");
                this.$emit("after");
              });
            })
            .complete(() => (this.loading = false));
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding-bottom: 0;
}
/deep/ .el-dialog__footer {
  padding-top: 0 !important;
}
/deep/ .el-collapse {
  background: #fff;
  overflow-Y: auto;
  border: 1px solid #cccccc;
  .el-collapse-item__header {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #cccccc;
    &.is-active {
      border-bottom: 1px solid #cccccc;
    }
    .margin_0_10 {
      margin: 0 10px;
    }
  }
  .el-collapse-item__wrap {
    border-bottom: 1px solid #cccccc;
  }
  .margin_left_36 {
    margin-left: 36px;
  }
  .el-button {
    margin-left: 0;
  }
}
/deep/ .el-form-item {
  margin-bottom: 20px;
}
.column_sta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
</style>
